import Logo from "../images/logo.svg";
import whiteLogo from "../images/white-logo.png";
const IMAGES = { Logo, whiteLogo };

export default IMAGES;
